// extracted by mini-css-extract-plugin
module.exports = {"priority":"_3o3o8sFE7Rdp"};